var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left-side-menu"},[_c('div',{staticClass:"sidebar-content"},[(!_vm.isCondensed)?_vm._m(0):_c('div',{attrs:{"id":"sidebar-menu"}},[_c('Appmenu')],1)],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('VuePerfectScrollbar',{staticClass:"slimscroll-menu",attrs:{"settings":_vm.settings}},[_c('div',{attrs:{"id":"sidebar-menu"}},[_c('Appmenu')],1)])
}]

export { render, staticRenderFns }